import React from 'react';
import FooterV1 from '../../components/footer/FooterV1';

const thStyle = {
  border: '1px solid #ddd',
  padding: '12px',
  textAlign: 'left',
  fontWeight: '600',
};

const tdStyle = {
  border: '1px solid #ddd',
  padding: '10px',
  color: '#333',
};

const AboutUs = () => {
  return (
    <>
      <div
        className="page-wrapper"
        style={{
          marginTop: '150px',
          maxWidth: '1200px',
          marginLeft: 'auto',
          marginRight: 'auto',
          marginBottom: '50px',
          padding: '0 20px',
        }}
      >
        <h2 style={{ color: '#9B1321', marginBottom: '10px' }}>
          Cancellation & No-Show Policy
        </h2>

        <h3>Conference Registration</h3>

        <p>
          To ensure proper planning and commitment for our conferences, all
          registration cancellations are subject to the following terms.
        </p>

        <p>
          Any refund, if applicable, will be calculated as a percentage of the
          total registration fee paid.
        </p>

        <h3 style={{ marginTop: '30px' }}>
          Cancellation Policy by Timeframe
        </h3>

        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            marginTop: '15px',
            backgroundColor: '#fff',
            boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
          }}
        >
          <thead>
            <tr style={{ backgroundColor: '#9B1321', color: '#fff' }}>
              <th style={thStyle}>
                Period Prior to Conference Start Date
              </th>
              <th style={thStyle}>Refund Policy</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={tdStyle}>
                More than 90 days prior to the conference
              </td>
              <td style={tdStyle}>
                50% refund of the registration fee
              </td>
            </tr>
            <tr>
              <td style={tdStyle}>
                60–89 days prior to the conference
              </td>
              <td style={tdStyle}>
                30% refund of the registration fee
              </td>
            </tr>
            <tr>
              <td style={tdStyle}>
                30–59 days prior to the conference
              </td>
              <td style={tdStyle}>No refund</td>
            </tr>
            <tr>
              <td style={tdStyle}>
                Less than 30 days prior to the conference
              </td>
              <td style={tdStyle}>No refund</td>
            </tr>
            <tr>
              <td style={tdStyle}>No-Show</td>
              <td style={tdStyle}>No refund</td>
            </tr>
          </tbody>
        </table>

        <h3 style={{ marginTop: '35px' }}>
          General Terms & Conditions
        </h3>

        <ul style={{ paddingLeft: '20px' }}>
          <li>
            All cancellation requests must be submitted in writing via the
            official conference email.
          </li>
          <li>
            The date of receipt of the written cancellation by the conference
            organizer will be considered the official cancellation date.
          </li>
          <li>
            Any bank charges, transaction fees, or transfer costs shall be borne
            by the registrant.
          </li>
          <li>
            Verbal cancellations or unofficial communications will not be
            accepted.
          </li>
          <li>
            Registration fees are non-transferable unless explicitly approved
            by the organizing committee.
          </li>
        </ul>

        <h3 style={{ marginTop: '30px' }}>
          Important Notice
        </h3>

        <p>
          By completing the registration and payment process, the participant
          acknowledges and agrees to the Cancellation & No-Show Policy stated
          above without exception.
        </p>
      </div>

      <FooterV1 />
    </>
  );
};

export default AboutUs;
